import api from "@/api";

export default {
  namespaced: true,
  state: {
    groupPages: [],
    groupPagesData: [],
    pagesData: [],
  },
  getters: {
    getGroupPages(state) {
      return state.groupPages;
    },
    getgroupPagesData(state) {
      return state.groupPagesData;
    },
    getpagesData(state) {
      return state.pagesData;
    },
  },
  mutations: {
    setGroupPages(state, data) {
      state.groupPages = data || [];
    },
  },
  actions: {
    fetchCorporateAdminPages({ commit }) {
      return new Promise((resolve, reject) => {
        api()
          .get("Corporates/corporateAdminPages", {
            headers: { Authorization: localStorage.getItem("JwtToken") },
          })
          .then((res) => {
            commit("setGroupPages", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            commit("setGroupPages", []);
            reject(err);
          });
      });
    },
    addGroupPages(_, payload) {
      return new Promise((resolve, reject) => {
        api()
          .post("Corporates/addGroupPages", payload, {
            headers: { Authorization: localStorage.getItem("JwtToken") },
          })
          .then((res) => resolve(res))
          .catch((err) => resolve(err));
      });
    },
    fetchUserPagesByUserId({ commit }, userId) {
      return new Promise((resolve, reject) => {
        api()
          .get(`Corporates/getUserPagesByUserId?userId=${userId}`, {
            headers: { Authorization: localStorage.getItem("JwtToken") },
          })
          .then((res) => {
            commit("setGroupPages", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            commit("setGroupPages", []);
            reject(err);
          });
      });
    },
  },
};
